import script from "./CentralizedInsuranceViewConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./CentralizedInsuranceViewConsent.vue?vue&type=script&setup=true&lang=js"

import "./CentralizedInsuranceViewConsent.vue?vue&type=style&index=0&id=2a54291b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a54291b"]])

export default __exports__